import { chain } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { addToStartOfChain, createChainHandler } from "@store/Modules/client-framework/HandlerCreator";

export const SetBaseParameter = createChainHandler("SetBaseParameter", chain, props => {
    // `includeAttributes: ["includeOnProduct"]` needs to be sent to the "getProductByPath" service within the "LoadProductIfNeeded" handler chain.
    (props.parameter as any) = { includeAttributes: ["includeOnProduct"], ...props.parameter };
});

addToStartOfChain(chain, SetBaseParameter);

export const SetAdditionalExpands = createChainHandler("SetAdditionalExpands", chain, props => {
    (props.parameter as any) = { additionalExpands: ["properties"], ...props.parameter };
});

addToStartOfChain(chain, SetAdditionalExpands);
